import { render, staticRenderFns } from "./RedirectToApp.vue?vue&type=template&id=18031512&"
import script from "./RedirectToApp.vue?vue&type=script&lang=js&"
export * from "./RedirectToApp.vue?vue&type=script&lang=js&"
import style0 from "./RedirectToApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports